import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

export const PATIENT_STATUS = [["active", "Active"], ["declined", "Patient declined"], ["clinically_not_fit", "Clinically not fit"]];

export default function PatientStatusControl({ p, reload, canEdit }) {
  const cur = p.patient_status || "active";
  const [pick, setPick] = useState(null);
  const [note, setNote] = useState("");
  const save = async () => {
    try { await api.post(`/patients/${p.id}/status`, { status: pick, note }); toast.success("Patient status updated (audited)"); setPick(null); setNote(""); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className={`rounded-md border p-3 ${cur === "active" ? "bg-white" : "bg-red-50 border-red-200"}`} data-testid="patient-status-panel">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="font-semibold text-sm">Patient status:</span>
        <span className={cur === "active" ? "text-green-700" : "text-red-700 font-semibold"} data-testid="patient-status-value">{PATIENT_STATUS.find(([v]) => v === cur)[1]}</span>
        {canEdit && <div className="ml-auto flex gap-1 flex-wrap">{PATIENT_STATUS.filter(([v]) => v !== cur).map(([v, l]) => (
          <Button key={v} size="sm" variant="outline" className="h-8" onClick={() => setPick(v)} data-testid={`patient-status-${v}`}>{v === "active" ? "Re-activate" : l}</Button>))}</div>}
      </div>
      {cur !== "active" && <p className="text-xs text-slate-600 mt-1">{p.patient_status_note} - {p.patient_status_by}, {p.patient_status_at?.slice(0, 16).replace("T", " ")}. New packets, visits and signing are blocked.</p>}
      {pick && (
        <div className="mt-2 space-y-2">
          <Textarea value={note} onChange={(e) => setNote(e.target.value)} placeholder={pick === "active" ? "Note (optional)" : "Reason (required)"} data-testid="patient-status-note" />
          <div className="flex gap-2"><Button size="sm" className="btn-brand" disabled={pick !== "active" && !note.trim()} onClick={save} data-testid="patient-status-save">Save</Button>
            <Button size="sm" variant="outline" onClick={() => setPick(null)}>Cancel</Button></div>
        </div>
      )}
    </div>
  );
}
